import React, { useState } from 'react';
import LandingPage from './LandingPage';
import LoginPage from './LoginPage';
import SuperAdminDashboard from './SuperAdminDashboard';
import MMDAAdminDashboard from './mmda/MMDAAdminDashboard';
import FieldOfficerDashboard from './field-officer/FieldOfficerDashboard';
import { API_CONFIG } from './config/api';

const App = () => {
  const [user, setUser] = useState(null);
  const [showLanding, setShowLanding] = useState(true);

  if (!user && !showLanding) {
    return <LoginPage onLogin={setUser} onBack={() => setShowLanding(true)} />;
  }

  if (!user && showLanding) {
    return <LandingPage onGetStarted={() => setShowLanding(false)} />;
  }

  // Debug logging


  if (user.role_name === 'super_admin') {
    return <SuperAdminDashboard user={user} onUserChange={setUser} />;
  }

  if (user.role_name === 'mmda_admin' || user.role_name === 'MMDA' || user.role_name === 'mmda') {
    // Suppress all console logs for mmda role
    console.log = () => {};
    return <MMDAAdminDashboard user={user} onUserChange={setUser} />;
  }

  if (user.role_name === 'field_officer') {
    return <FieldOfficerDashboard user={user} onUserChange={setUser} apiConfig={API_CONFIG} />;
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '400px'
      }}>
        <h2 style={{ color: '#f44336', marginBottom: '20px' }}>Access Denied</h2>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          Your role ({user.role_name}) does not have access to this dashboard.
        </p>
        <p style={{ color: '#666', fontSize: '14px' }}>
          Supported roles: SuperAdmin, MMDA Admin, Field Officer
        </p>
        <button
          onClick={() => setUser(null)}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default App;
